export { default as Img200 } from './processed/200/Americans-The-S6.jpg';
export { default as Img400 } from './processed/400/Americans-The-S6.jpg';
export { default as Imgthumb } from './processed/thumb/Americans-The-S6.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Americans-The-S6.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Americans-The-S6.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      250,
      226,
      5
    ],
    "_population": 2149,
    "_hsl": [
      0.15034013605442179,
      0.9607843137254901,
      0.5
    ]
  },
  "LightVibrant": {
    "_rgb": [
      240,
      240,
      132
    ],
    "_population": 2,
    "_hsl": [
      0.16666666666666666,
      0.7826086956521738,
      0.7294117647058824
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      4,
      26,
      152
    ],
    "_population": 3465,
    "_hsl": [
      0.6418918918918919,
      0.9487179487179486,
      0.3058823529411765
    ]
  },
  "Muted": {
    "_rgb": [
      103,
      166,
      140
    ],
    "_population": 19,
    "_hsl": [
      0.4312169312169312,
      0.26141078838174275,
      0.5274509803921569
    ]
  },
  "DarkMuted": {
    "_rgb": [
      70,
      74,
      61
    ],
    "_population": 79,
    "_hsl": [
      0.21794871794871792,
      0.09629629629629632,
      0.2647058823529412
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Americans-The-S6.js